import { Controller } from '@hotwired/stimulus'

// Hidden popup iframes have a 0x0 viewport
export default class extends Controller {
  static values = { url: String, token: String }

  connect() {
    this.recorded = false
    this.onResize = () => this.recordIfDisplayed()
    window.addEventListener('resize', this.onResize)
    this.recordIfDisplayed()
  }

  disconnect() {
    window.removeEventListener('resize', this.onResize)
  }

  recordIfDisplayed() {
    if (this.recorded || window.innerWidth === 0 || window.innerHeight === 0)
      return
    this.recorded = true
    window.removeEventListener('resize', this.onResize)

    fetch(this.urlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.tokenValue,
        Accept: 'application/json',
      },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.run) this.runAfterConsentJs(data.run)
      })
      .catch(() => {
        // Best-effort tracking, ignore network errors
      })
  }

  runAfterConsentJs(js) {
    const script = document.createElement('script')
    script.textContent = js
    document.head.appendChild(script)
  }
}
